import clsx from "clsx";

export const TableHeaderRow = ({ children }: { children: React.ReactNode }) => {
    return (
        <tr className="bg-backgroundGrey py-4 h-10 text-greyishBlue font-medium">
            {children}
        </tr>
    )
}

export const TableHeader = ({ children, additionalClasses }: { children: React.ReactNode; additionalClasses?: string; }) => {
    return (
        <th className={clsx("z-10 sticky bg-inherit top-0 font-medium border-b border-solid border-borderGrey", additionalClasses)}>
            {children}
        </th>
    )
}

export const TableBodyRow = ({ children, additionalClasses, isSelected, ...rest }: { children: React.ReactNode; additionalClasses?: string; isSelected?: boolean; [key: string]: any; }) => {
    return (
        <tr {...rest} className={clsx("h-11 bg-white hover:bg-backgroundBlueLight text-xs", additionalClasses, {"!bg-backgroundBlueLight": isSelected})}>
            {children}
        </tr>
    )
}

export const TableData = ({ children, additionalClasses, ...rest  }: { children: React.ReactNode; additionalClasses?: string; [key: string]: any; }) => {
    return (
        <td className={clsx(additionalClasses,
            "truncate px-2 max-w-80")}
        >
            {children}
        </td>
    )
}